const validateDesc = function (errors) {
  return true
}

const validateOption = function (errors) {
  const optionList = this.optionList
  if (optionList && optionList.some(item => !item.optionTitle)) {
    errors.push('选项内容不能为空！')
    return false
  }
  return true
}

const validate = function () {
  const errors = []
  return {
    result: validateDesc.call(this, errors) & validateOption.call(this, errors),
    errors
  }
}

export default {
  validateDesc,
  validateOption,
  validate
}



// WEBPACK FOOTER //
// ./src/components/editor/RateBox/validate.js